import React from 'react';
import LocationTemplate from './LocationTemplate';

const WilsonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wilson"
      stateName="North Carolina"
      countyName="Wilson"
      zipCodes={["27893", "27894", "27895", "27896"]}
      latitude={35.7212}
      longitude={-77.9155}
      population={49459}
      historicalFact="Founded in 1849, named after Louis Dicken Wilson; known for antique shopping and historic downtown."
      nearbyTowns={[
        "Rocky Mount, NC",
        "Goldsboro, NC",
        "Greenville, NC",
        "Nashville, NC",
        "Tarboro, NC",
        "Kinston, NC",
        "Elm City, NC",
        "Black Creek, NC"
      ]}
    />
  );
};

export default WilsonPage;